import React from 'react';
import { Flex, Tooltip } from 'antd';
import {
    ClockCircleOutlined,
    DeleteOutlined,
    EditOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { RecommendationProps } from '../service/recommendations.interface';
import { useTheme } from '../../../../../hooks/useTheme';
import { ConfirmationDialog } from '../../../../../shared/ui/ConfirmationDialog';
import { useDeleteRecommendationMutation } from '../service/recommendations-ai.api';
import { useAppDispatch } from '../../../../../store';
import { setCurrentRecommendation } from '../store/recommendationAISlice';

export const RecommendationsControlsIcons = (
    recommendation: RecommendationProps
) => {
    const { colorIcon } = useTheme();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const selectCurrent = () => {
        dispatch(setCurrentRecommendation(recommendation));
    };

    const [deleteRecommendation] = useDeleteRecommendationMutation();

    const handleDeleteRecommendations = (id: number) => {
        deleteRecommendation(id);
    };

    const handleViewRecommendationHistory = () => {
        selectCurrent();
        navigate(`history`);
    };

    const handleEditRecommendation = () => {
        selectCurrent();
        navigate(`edit`);
    };

    const styles = {
        fontSize: '20px',
        color: colorIcon,
        cursor: 'pointer',
    };

    return (
        <Flex gap={10}>
            <Tooltip title={'История'}>
                <ClockCircleOutlined
                    onClick={handleViewRecommendationHistory}
                    style={styles}
                />
            </Tooltip>

            <Tooltip title={'Редактировать'}>
                <EditOutlined
                    onClick={handleEditRecommendation}
                    style={styles}
                />
            </Tooltip>

            <ConfirmationDialog
                activator={
                    <Tooltip title={'Удалить'}>
                        <DeleteOutlined style={styles} />{' '}
                    </Tooltip>
                }
                onConfirm={() => handleDeleteRecommendations(recommendation.id)}
                title='Удалить рекомендацию'
                description={`Вы уверены что хотите удалить выбранную рекомендацию? Восстановить историю после удаления будет невозможно. `}
            />
        </Flex>
    );
};
